import { Box } from "@mui/material";
import React, { useState } from "react";
import WorkOrderForm from "../../Common/WorkOrderForm";
import NonDimentionalRFIDetails from "./NonDimentionalRFIDetails";
import useNonDimentionalRFI from "../../../hooks/useNonDimentionalRFI";
import RfiHeader from "../RfiHeader";

const NonDimentionalRFI = ({ rfiDetails }) => {
  const [collapsibleOpen, setCollapsibleOpen] = useState(true);
  const { formik, removeFile, addFiles, isFetching, isUpdating, actions } =
    useNonDimentionalRFI();
  return (
    <Box>
      <RfiHeader
        rfiDetails={rfiDetails}
        type="non-dimentional"
        actions={actions}
      />
      <Box mt={9}>
        <WorkOrderForm
          fields={rfiDetails}
          editable={false}
          collapsibleOpen={collapsibleOpen}
          setCollapsibleOpen={setCollapsibleOpen}
        />
        <NonDimentionalRFIDetails
          formik={formik}
          rfiDetails={rfiDetails}
          removeFile={removeFile}
          addFiles={addFiles}
          isFetching={isFetching}
          isUpdating={isUpdating}
        />
      </Box>
    </Box>
  );
};

export default NonDimentionalRFI;
